<form [formGroup]="form">
  <div class="row">
    @for (exc of templateExerciseList(); track exc.id; let index = $index) {
      <div class="col-12 col-md-6">
        <sana-tp-exercise-template-edit-list-entry-item
          [exercise]="exc"
          [listIdx]="index"
          [exerciseFormArray]="getFormArray()"
          (removeExercise)="removeFromTherapyPlan($event, index)"></sana-tp-exercise-template-edit-list-entry-item>
      </div>
    }
  </div>
</form>

